import { Directive, Input } from '@angular/core';
import { ModalProps } from '@app/core/components/modal/modal-props';
import { ModalComponent } from '@app/core/pcs-modal/model/modal';
import { PcsTranslateService } from '@app/core/translate/translate.service';
import { Action, Store } from '@ngrx/store';
import * as R from 'ramda';

@Directive()
export abstract class PcsModalDirective implements ModalComponent {
  @Input() props: ModalProps;

  constructor(protected store: Store<any>,
    protected translateService: PcsTranslateService) {
  }

  onConfirm() {
    if (this.props.confirmActions) {
      R.forEach((action: Action) => this.store.dispatch(action), this.props.confirmActions);
    }
  }

  onClose() {
    if (this.props.customCancelActions) {
      R.forEach((action: Action) => this.store.dispatch(action), this.props.customCancelActions);
    }
  }

  getMessage({messageInfo: {message, messageParams}}: ModalProps) {
    return this.translateService.translate(message, messageParams);
  }

  get messageInfo() {
    return this.props && this.props.messageInfo;
  }

  get titleText() {
    return this.getMessageInfoProperty('titleText');
  }

  get buttonText() {
    return this.getMessageInfoProperty('buttonText');
  }

  get cancelButtonText() {
    return this.getMessageInfoProperty('cancelBtnText', 'general.action.cancel');
  }

  get confirmActions() {
    return this.props && this.props.confirmActions;
  }

  getMessageInfoProperty(property, defaultValue = '') {
    return R.propOr(defaultValue, property)(this.messageInfo);
  }
}
